<template>
    <div class="site-updated">
        <div class="zems"></div>
        <div class="text-size-m mt16 text-center">
			Друзья, мы обновили сайт!<br>
			Пожалуйста, обновите страницу, чтобы изменения вступили в силу.
        </div>
        <a href="." @click.prevent="updateVersion()" class="btn btn--ico mt16">
            Спасибо, Екатерина!
        </a>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "NotifyReset",
    computed: {
        ...mapState({
            popups: state => state.popups.items,
        })
    },
    methods: {
        updateVersion: function () {
            if (this.popups.addRule.show) {
                this.$store.commit('popups/open', {name: this.popups.tryingUpdate.name});

            } else {
                window.location.reload();
            }
        },
    }
}
</script>
